var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.515,
    height: 25.291,
    viewBox: "0 0 19.515 25.291",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_391",
    "data-name": "Trac\\xE9 391",
    d: "M492.84,200.833a.923.923,0,0,0-.678-.3h-9.808a2.59,2.59,0,0,0-2.587,2.587V223.04a2.59,2.59,0,0,0,2.587,2.588h14.14a2.591,2.591,0,0,0,2.588-2.588V207.952a.925.925,0,0,0-.245-.627Zm4.02,7.07h0Zm-.365,15.88h-14.14a.743.743,0,0,1-.742-.743V203.124a.743.743,0,0,1,.742-.743h9.4l.087.094v5.857a.431.431,0,0,0,.431.431h4.962V223.04A.745.745,0,0,1,496.495,223.783Z",
    transform: "translate(-479.668 -200.437)",
    fill: "#181a3a",
    stroke: "#181a3a",
    strokeWidth: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.a03ccc122dac2f3b0e57ad76edce0203.svg";
export { ForwardRef as ReactComponent };